/* Version: 3.5.137 */
'use client';
import 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

var instagramIcon = (function (_ref) {
  var alt = _ref.alt;
  return /*#__PURE__*/jsxs("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    children: [/*#__PURE__*/jsx("title", {
      children: alt
    }), /*#__PURE__*/jsx("path", {
      d: "M10.9396484,0 C13.1785547,0 15,1.82144531 15,4.06035156 L15,4.06035156 L15,10.9398047 C15,13.1785547 13.1785547,15 10.9398047,15 L10.9398047,15 L4.06035156,15 C1.82144531,15 0,13.1785547 0,10.9398047 L0,10.9398047 L0,4.06035156 C0,1.82144531 1.82144531,0 4.06035156,0 L4.06035156,0 Z M7.265625,3.28125 C5.06863282,3.28125 3.28125,5.06863282 3.28125,7.265625 C3.28125,9.46261718 5.06863282,11.25 7.265625,11.25 C9.46261718,11.25 11.25,9.46261718 11.25,7.265625 C11.25,5.06863282 9.46261718,3.28125 7.265625,3.28125 Z M7.265625,5.15625 C8.42879377,5.15625 9.375,6.10245623 9.375,7.265625 C9.375,8.42869147 8.42879377,9.375 7.265625,9.375 C6.10255853,9.375 5.15625,8.42869147 5.15625,7.265625 C5.15625,6.10245623 6.10255853,5.15625 7.265625,5.15625 Z M11.6995312,1.94183594 C11.0311719,1.94183594 10.4875,2.48550781 10.4875,3.15382813 C10.4875,3.8221875 11.0311719,4.36585938 11.6995312,4.36585938 C12.3678516,4.36585938 12.9115234,3.8221875 12.9115234,3.15382813 C12.9115234,2.48550781 12.3678516,1.94183594 11.6995312,1.94183594 Z"
    })]
  });
});

export { instagramIcon as default };
